import { type InsuranceCorporateIdentity } from "../types";

export function PolizeiLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_58_16">
          <rect
            width="413"
            height="81"
            fill="white"
            transform="translate(50 215)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_58_16)">
        <path
          d="M50.3485 216.397H78.5789C95.308 216.397 110.295 220.935 110.295 241.534C110.295 262.483 93.9139 267.022 78.2304 267.022H67.0776V294.953H50V216.397H50.3485ZM78.9274 253.405C89.7316 253.405 93.5654 249.216 93.5654 241.884C93.5654 234.552 89.7316 230.362 78.9274 230.362H67.0776V253.405H78.9274Z"
          fill="white"
        />
        <path
          d="M117.265 255.5C117.265 227.918 135.04 215 154.208 215C173.029 215 190.803 227.918 190.803 255.5C190.803 283.082 173.029 296 154.208 296C135.04 296 117.265 283.082 117.265 255.5ZM173.726 255.5C173.726 239.091 166.058 229.315 154.208 229.315C142.01 229.315 134.691 239.091 134.691 255.5C134.691 271.909 142.01 282.384 154.208 282.384C166.058 282.034 173.726 271.909 173.726 255.5Z"
          fill="white"
        />
        <path
          d="M203.699 216.397H220.776V280.638H255.28V294.603H203.699V216.397Z"
          fill="white"
        />
        <path
          d="M281.768 216.397H264.69V294.603H281.768V216.397Z"
          fill="white"
        />
        <path
          d="M296.406 282.733L337.183 230.711H299.194V216.397H358.792V228.616L319.06 280.638H358.792V294.603H296.406V282.733Z"
          fill="white"
        />
        <path
          d="M373.43 216.397H426.754V230.711H390.856V247.47H416.646V261.086H390.856V280.638H428.496V294.603H373.43V216.397Z"
          fill="white"
        />
        <path d="M463 216.397H445.922V294.603H463V216.397Z" fill="white" />
      </g>
    </svg>
  );
}

export const Polizei: InsuranceCorporateIdentity = {
  id: "polizei",
  name: "Polizei BKK",
  logo: PolizeiLogo,
  backgroundColor: "#0061A7",
  textColor: "#FFFFFF",
  wildcard: { or: ["polizei", "pol "] },
  type: "statutory",
};
